import { Fragment, useState, useEffect } from 'react';
import { Marker } from 'react-leaflet';
import L from 'leaflet';

export const ExpandedCluster = ({ group, maxDensity, totalSpots, onSelect, config, onClose, CrimeMarker }) => {
    const [progress, setProgress] = useState(0);

    // Animação de expansão matemática (60fps via requestAnimationFrame)
    useEffect(() => {
        let start = null;
        let animationFrameId;
        const duration = 250; // Duração do "deslizamento" em ms
        
        const animate = (time) => {
            if (!start) start = time;
            const elapsed = time - start;
            const currentProgress = Math.min(elapsed / duration, 1);
            
            // Efeito Cubic Ease-Out para um deslizamento suave que desacelera no final
            const easeOut = 1 - Math.pow(1 - currentProgress, 3);
            setProgress(easeOut);
            
            if (currentProgress < 1) {
                animationFrameId = requestAnimationFrame(animate);
            }
        };
        
        animationFrameId = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animationFrameId);
    }, []);

    // Animação CSS spin-in no botão de fechar
    const closeHtml = `<div style="
        background-color: #333; 
        color: white; 
        border-radius: 50%; 
        width: 12px; 
        height: 12px; 
        display: flex; 
        align-items: center; 
        justify-content: center; 
        font-size: 12px; 
        font-weight: bold; 
        font-family: sans-serif; 
        border: 2px solid white; 
        cursor: pointer; 
        box-shadow: 0 0 6px rgba(0,0,0,0.5);
        animation: spinIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
    ">X</div>`;

    const closeIcon = L.divIcon({
        html: closeHtml,
        className: "",
        iconSize: [12, 12],
        iconAnchor: [10, 10]
    });

    // O offset inicia em 0 (centro) e vai até 0.00030
    const targetOffset = 0.00030;
    const currentOffset = targetOffset * progress;

    return (
        <Fragment>
            <Marker 
                position={[group.latitude, group.longitude]}
                icon={closeIcon}
                eventHandlers={{ click: onClose }}
            />
            {group.spots.map((spot, index) => {
                const angle = (index / group.spots.length) * 2 * Math.PI;
                const offsetLat = group.latitude + currentOffset * Math.cos(angle);
                const offsetLng = group.longitude + currentOffset * Math.sin(angle);
                
                return (
                    <CrimeMarker
                        key={`${group.id}_${index}`}
                        spot={{...spot, latitude: offsetLat, longitude: offsetLng}}
                        density={group.density}
                        maxDensity={maxDensity}
                        totalSpots={totalSpots}
                        onSelect={onSelect}
                        config={config}
                    />
                );
            })}
        </Fragment>
    );
};